module.exports = Object.getPrototypeOf;